import type React from 'react';

export type MobileOrDesktopRendererProps = {
    mobileContent?: React.JSX.Element;
    desktopContent?: React.JSX.Element;
    customBreakPoint?: 'md' | 'xl';
};

/**
 * This component is beneficial for server-side rendering (SSR) scenarios,
 * where we need to render the content before javascript is initialized.
 * Since it renders both contents and one is just hidden with css media query,
 * it should be used only with lightweight components.
 * For example skeletons.
 */
const MobileOrDesktopRendererSSR: React.FC<MobileOrDesktopRendererProps> = ({
    desktopContent,
    mobileContent,
    customBreakPoint
}) => {
    if (!desktopContent && !mobileContent) {
        return null;
    }

    let customDesktopBreakPoint: string;
    let customMobileBreakPoint: string;

    switch (customBreakPoint) {
        case 'md':
            customDesktopBreakPoint = 'hidden md:block';
            customMobileBreakPoint = 'block md:hidden';
            break;
        case 'xl':
            customDesktopBreakPoint = 'hidden xl:block';
            customMobileBreakPoint = 'block xl:hidden';
            break;
        default:
            customDesktopBreakPoint = 'hidden lg:block';
            customMobileBreakPoint = 'block lg:hidden';
            break;
    }

    return (
        <>
            {desktopContent && <div className={customDesktopBreakPoint}>{desktopContent}</div>}
            {mobileContent && <div className={customMobileBreakPoint}>{mobileContent}</div>}
        </>
    );
};

export default MobileOrDesktopRendererSSR;
